import { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  TextField,
} from "@mui/material";
import Select from "react-select";
import API from "../../config/api";
import { useIsMobile } from "../../hooks/useIsMobile";
import styles from "./membersRecurring.module.scss";

const MembersRecurring = () => {
  const [members, setMembers] = useState([]);
  const [services, setServices] = useState([]);
  const isMobile = useIsMobile();
  const [openDialog, setOpenDialog] = useState(false);
  const [form, setForm] = useState({});

  const handleClose = () => {
    setOpenDialog(false);
  };

  const handleOpenDialog = (memberId) => {
    const member = members.find((m) => m.id === memberId);
  
    setForm((prev) => ({
      ...prev,
      owner: {
        name: `${member.names} ${member.familyName}`,
        id: member.id,
        reference: member.identifier,
        membershipToPay: member.membershipToPay
      },
      ownerType: "member",
    }));
    setOpenDialog(true);
  };

  const handleSelectChange = (newValue) => {
    console.log("INPUT--", newValue);
    setForm(prev => ({
      ...prev,
      membershipSelected: newValue.value
    }))
  };

  const handleInputChange = (e) => {
    const {name, value} = e.target;

    setForm(prev => ({
      ...prev,
      [name]: value
    }))
  }
  
  const handleSetMembership = () => {
    const service = services.find((s) => s.value === form.membershipSelected);
  
    setForm((prev) => ({
      ...prev,
      services: {
        [service.value]: {
          description: service.data.description,
          isMembership: true,
          price: service.data.price,
          quantity: form.quota,
          discount: 0,
          accountNumber: service.data.accountNumber,
          id: service.value,
          currency: "DOP",
          excludeTax: false,
        },
      },
    }));
  };

  const handlePayRecurring = () => {
    setForm((prev) => ({
      ...prev,
      paymentType: "creditCard",
    }));
  };

  useEffect(() => {
    (async () => {
      const recurring = await API.get("member/members_recurring");
      const membershipServices = await API.get(
        "service/all?status=active&isMembership=true&sort=currentPrice"
      );

      setMembers(recurring.body.data);
      setServices(
        membershipServices.body.data.map((r) => ({
          value: r.id,
          label: r.description,
          data: {
            accountNumber: r.accountNumber,
            price: r.price,
            currency: r.currency,
            description: r.description,
          },
        }))
      );
    })();
  }, []);

 // console.log("IS MOBILE---", form.quota);
  return (
    <div>
      <h4>Lista de recurrentes</h4>
      <div>Total: {members.length}</div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
            <TableRow>
              <TableCell>Nombres</TableCell>
              {!isMobile ? <TableCell>Apellidos</TableCell> : null}
              <TableCell>Cuotas pend.</TableCell>
              <TableCell>Código Colegio</TableCell>
              <TableCell>Cédula</TableCell>
              <TableCell>Acción</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {members?.length > 0
              ? members.map((member, idx) => (
                  <TableRow
                    key={`${member.id}`}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell component="th" scope="row">
                      {member.names} {isMobile ? member.familyName : ""}
                    </TableCell>
                    {!isMobile ? (
                      <TableCell>{member.familyName}</TableCell>
                    ) : null}
                    <TableCell>{member.membershipToPay}</TableCell>
                    <TableCell>{member.codeSchool}</TableCell>
                    <TableCell>{member.identifier}</TableCell>
                    <TableCell>
                      <Button onClick={() => handleOpenDialog(member.id)}>
                        Pagar cuotas
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
              : null}
          </TableBody>
        </Table>
      </TableContainer>

      {openDialog ? (
        <Dialog
          open={openDialog}
          onClose={handleClose}
          fullWidth
          maxWidth={"sm"}
          slotProps={{
            paper: {
              classes: { root: styles.dialog },
            },
          }}
        >
          <DialogTitle>Cuotas a pagar</DialogTitle>
          <DialogContent classes={{ root: styles.dialog }}>
            <h4>Titular</h4>
            <div>
              <label>Nombre</label>
              <p>{form.owner.name}</p>
            </div>
            <div>
              <label>Cuotas pendientes</label>
              <p>{form.owner.membershipToPay}</p>
            </div>
            <DialogContentText>
              Digitar la cantidad de coutas a cobrar.
            </DialogContentText>
            <div className={styles.dialog_form}>
              <div className={styles.form_inputs}>
                <Select
                  name="service"
                  className={`${styles.servicesDropdown} ${styles.membership_service_drop_down}`}
                  classNamePrefix="membership_service"
                  options={services}
                  onChange={handleSelectChange}
                  //isDisabled={isDisabled}
                  styles={{
                    menu: (provided) => ({ ...provided, zIndex: 9999 }),
                    control: (baseStyles) => ({
                      ...baseStyles,
                      padding: "10px",
                    }),
                  }}
                />
                <TextField
                  autoFocus
                  required
                  margin="dense"
                  id="name"
                  name="quota"
                  label="Cuotas"
                  type="number"
                  variant="outlined"
                  value={form.quota || 1}
                  onChange={handleInputChange}
                  inputProps={{ min: 1, max: 12 }}
                />
              </div>
            </div>
            <Button
              variant="contained"
              onClick={handleSetMembership}
              color="secondary"
            >
              Agregar Servicio
            </Button>
          </DialogContent>
        </Dialog>
      ) : null}
    </div>
  );
};

export default MembersRecurring;
